import { render, staticRenderFns } from "./ObjectActivityItem.vue?vue&type=template&id=3fd46c7b&scoped=true&"
import script from "./ObjectActivityItem.vue?vue&type=script&lang=js&"
export * from "./ObjectActivityItem.vue?vue&type=script&lang=js&"
import style0 from "./ObjectActivityItem.vue?vue&type=style&index=0&id=3fd46c7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd46c7b",
  null
  
)

export default component.exports